import throttle from "lodash/throttle";
//@ts-ignore
import styles from './style.module.css';
import { Editor } from "slate";
import { checkIfInsideTable } from "../../utils";

const OFFSET = 50;
const PX_DIFF = 8; // Increased for faster scrolling with big images
const LARGE_IMAGE_THRESHOLD = 200; // Height threshold to detect large images

let scrollIncrement = 0;
let isScrolling = false;
let sidebarElement = null;
let scrollHeightSidebar = 0;
let clientRectBottom = 0;
let clientRectTop = 0;
let previewElement = null;
let previewRef = null;
let editorContainer = null;
let editorBounds = null;

const goUp = () => {
    // Dynamic scrolling speed based on content size
    const dynamicPxDiff = getDynamicScrollSpeed();
    scrollIncrement -= dynamicPxDiff;
    sidebarElement.scrollTop = scrollIncrement;

    if (isScrolling && sidebarElement.scrollTop > 0) {
        window.requestAnimationFrame(goUp);
    } else {
        isScrolling = false;
    }
};

const goDown = () => {
    const dynamicPxDiff = getDynamicScrollSpeed();
    scrollIncrement += dynamicPxDiff;
    sidebarElement.scrollTop = scrollIncrement;

    const canScrollMore = sidebarElement.scrollTop < (sidebarElement.scrollHeight - sidebarElement.clientHeight);
    if (isScrolling && canScrollMore) {
        window.requestAnimationFrame(goDown);
    } else {
        isScrolling = false;
    }
};

const getDynamicScrollSpeed = () => {
    // Check if we're dragging a large image by examining preview content
    if (previewElement && typeof previewElement.querySelectorAll === 'function') {
        const images = previewElement.querySelectorAll('img');
        const hasLargeImage = Array.from(images).some((img: HTMLImageElement) => img.naturalHeight > LARGE_IMAGE_THRESHOLD);
        return hasLargeImage ? PX_DIFF * 2 : PX_DIFF; // Double speed for large images
    }
    return PX_DIFF;
};

const onDragOver = event => {
    if (!sidebarElement) return;

    // Check if we can scroll up (not at top)
    const canScrollUp = sidebarElement.scrollTop > 0;
    // Check if we can scroll down (not at bottom)
    const canScrollDown = sidebarElement.scrollTop < (sidebarElement.scrollHeight - sidebarElement.clientHeight);

    const isMouseOnTop =
        canScrollUp &&
        event.clientY > clientRectTop &&
        event.clientY < clientRectTop + OFFSET;
    const isMouseOnBottom =
        canScrollDown &&
        event.clientY > clientRectBottom - OFFSET &&
        event.clientY <= clientRectBottom;

    if (!isScrolling && (isMouseOnTop || isMouseOnBottom)) {
        isScrolling = true;
        scrollIncrement = sidebarElement.scrollTop;

        if (isMouseOnTop) {
            window.requestAnimationFrame(goUp);
        } else {
            window.requestAnimationFrame(goDown);
        }
    } else if (!isMouseOnTop && !isMouseOnBottom) {
        isScrolling = false;
    }
};

const throttleOnDragOver = throttle(onDragOver, 50); 

const addEventListenerForSidebar = (elementId, document) => {
    const scrollerElement = document.getElementById(elementId);
    
    sidebarElement = scrollerElement?.querySelector('.scrte-editable') || scrollerElement;
    
    if (!sidebarElement) {
        console.warn('ScrollPanel element not found for drag scrolling');
        return;
    }
    
    scrollHeightSidebar = sidebarElement.scrollHeight;
    const clientRect = sidebarElement.getBoundingClientRect();
    clientRectTop = clientRect.top;
    clientRectBottom = clientRect.bottom;
    sidebarElement.addEventListener("dragover", throttleOnDragOver);
    
    editorContainer = sidebarElement.closest('.super-charged-rte') || sidebarElement;
    editorBounds = editorContainer.getBoundingClientRect();
};

const removeEventListenerForSidebar = () => {
    isScrolling = false;

    if (sidebarElement) {
        sidebarElement.removeEventListener("dragover", throttleOnDragOver);
    }
    
    editorContainer = null;
    editorBounds = null;
};
const handleMousemove = (event) => {
    previewElement = previewRef.current
    if (previewElement) {
        previewElement.style['display'] = 'block'
        
        // Simple positioning like original - follow mouse cursor closely
        let x = event.x + 8;
        let y = event.y - 13; // Convert 0.8rem to pixels (assuming 16px base)
        
        // Only apply minimal viewport constraints to keep preview visible
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const previewRect = previewElement.getBoundingClientRect();
        
        // Prevent going off-screen right
        if (x + previewRect.width > viewportWidth - 10) {
            x = viewportWidth - previewRect.width - 10;
        }
        
        // Prevent going off-screen left
        if (x < 10) {
            x = 10;
        }
        
        // Prevent going off-screen bottom
        if (y + previewRect.height > viewportHeight - 10) {
            y = viewportHeight - previewRect.height - 10;
        }
        
        // Prevent going off-screen top
        if (y < 10) {
            y = 10;
        }
        
        previewElement.style['transform'] = `translate(${x}px, ${y}px)`;
    }
}
const throttleOnMouseMove = handleMousemove;
const addEventListenerForPreview = (previewref, window) => {
    previewRef = previewref
    window.addEventListener("dragover", throttleOnMouseMove)
}
const removeEventListenerForPreview = (window) => {
    window.removeEventListener("dragover", throttleOnMouseMove)
}
export { getDynamicScrollSpeed };
export default {
    addEventListenerForSidebar,
    removeEventListenerForSidebar,
    addEventListenerForPreview,
    removeEventListenerForPreview
};


export const getDnDRTLClasses = (props, dndStyles, classesFor: 'container' | 'draggable' ):string  => {
    try {
        const {
            elementtype,
            isNodeRTLDirected,
            editor,
            path
        } = props
        if (!isNodeRTLDirected) return ""
        if (elementtype === 'tr') {
            if (classesFor === 'container') {
                return dndStyles?.['draggable-container-rtl'] ? dndStyles?.['draggable-container-rtl'] : styles?.['draggable-container-rtl']
            } else {
                return dndStyles?.['draggable-rtl'] ? dndStyles?.['draggable-rtl'] : styles?.['draggable-rtl']
            }
        } else if (elementtype === 'li') {
            if (classesFor !== 'draggable') return ""
            if (checkIfInsideTable(editor, path)) {
                return dndStyles?.['draggable-rtl-table-list'] ? dndStyles?.['draggable-rtl-table-list'] : styles?.['draggable-rtl-table-list']
            } else {
                return dndStyles?.['draggable-rtl-list'] ? dndStyles?.['draggable-rtl-list'] : styles?.['draggable-rtl-list']
            }
        }
        return '' 
    } catch (error) {
        console.error(error);
        return '';
    }

}
